import { Grid, Stack } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import { dateformat } from '../../../helpers';
import * as ROUTES from '../../../router/Routes';
import { DrawerWidget, ModalComponent } from '../../../widgets';
import BotonFechasComponent from '../../accesos/components/BotonFechas';
import SwitchFechaComponent from '../../accesos/components/SwitchFecha';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { allEntMonedasAction } from '../../entidad/ent_monedas/EntMonedasAction';
import { allEstatusAction } from '../../sistema/estatus/EstatusAction';
import { allRecibosAction, setActivoRecibosAction } from './RecibosAction';
import { PARAMS_RECIBOS } from './RecibosReducer';
import FiltrosRecibosComponent from './components/FiltrosRecibos';
import FormRecibos from './components/FormRecibos';
import ListadoRecibos from './components/ListadoRecibos';
import TextFiltrosRecibosComponent from './components/TextFiltrosRecibos';

const RecibosView = () => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();

  const recibosStore = Redux.useSelector((state) => state.recibos);
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const estatusStore = Redux.useSelector((state) => state.estatus);
  const entMonedasStore = Redux.useSelector((state) => state.entMonedas);

  const [openModalForm, setOpenModalForm] = React.useState(false);
  const [isFiltros, setIsFiltros] = React.useState(false);

  const [isRango, setIsRango] = React.useState(false);
  const [isFuturo, setIsFuturo] = React.useState(true);

  React.useEffect(() => {
    async function fetchData() {
      if (entMonedasStore.all.length === 0) {
        await allEntMonedasAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }
      if (estatusStore.all.length === 0) {
        await allEstatusAction(dispatch);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    setIsFiltros(isRango);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRango]);

  const botonFecha = (
    <Stack direction="row" spacing={2} alignItems="center">
      <BotonFechasComponent
        futuro={isFuturo}
        start={dateformat(recibosStore.params.desde, { dateOnly: true })}
        end={dateformat(recibosStore.params.hasta, { dateOnly: true })}
        dateRango={async (start, end) => {
          const payload = {
            ...recibosStore.params,
            desde: dateformat(start, {}),
            hasta: dateformat(end, {}),
          };
          dispatch({
            type: PARAMS_RECIBOS,
            payload,
          });
          await allRecibosAction(dispatch, payload);
        }}
        setIsRango={(e) => setIsRango(e)}
      />
      {(recibosStore.params.desde !== recibosStore.params.hasta || isRango) && (
        <SwitchFechaComponent
          value={isFuturo}
          onClickLeft={() => setIsFuturo(false)}
          onClickRigth={() => setIsFuturo(true)}
          onChange={(e) => setIsFuturo(e.target.checked)}
        />
      )}
    </Stack>
  );

  return (
    <Grid container spacing={1}>
      <Grid
        item
        md={12}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <BotonComponent
            click={async () => {
              await setActivoRecibosAction(dispatch, null);
              setOpenModalForm(true);
            }}
            green
            mr={2}
            addIcon
          />
          <BotonComponent
            click={async () => {
              await setActivoRecibosAction(dispatch, null);
              await allRecibosAction(dispatch, recibosStore.params);
            }}
            disabled={recibosStore.loadingAll || recibosStore.all.length === 0}
            white
            refreshIcon
            text={recibosStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
            mr={2}
          />
          {recibosStore.all.length > 0 && (
            <BotonComponent
              text="EXPORTAR PDF"
              click={() => {
                history.push(ROUTES.recibosPdf.to);
              }}
              red
              downloadIcon
              mr={2}
            />
          )}
        </div>
        <Stack direction="row" justifyContent="flex-end">
          {botonFecha}
          <BotonComponent
            text={`FILTROS ${isFiltros ? 'ACTIVO' : ''}`}
            filterIcon
            click={() => setIsFiltros(!isFiltros)}
            white={!isFiltros}
            blue={isFiltros}
            ml={2}
          />
        </Stack>
      </Grid>
      <Grid item md={12}>
        <TextFiltrosRecibosComponent />
        <ListadoRecibos setOpenModalForm={setOpenModalForm} />
      </Grid>
      <DrawerWidget open={isFiltros} onClose={(val) => setIsFiltros(val)}>
        <FiltrosRecibosComponent isRango={isRango} />
      </DrawerWidget>
      <ModalComponent
        id="modalFormRecibos"
        title={`Recibos`}
        open={openModalForm}
        maxWidth="lg"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormRecibos
          activo={estudiantesStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default RecibosView;
